<template>
	<div>
		<div class="vh-100 bg-grey">
			<SOTitleBar
				:page-title="'Daftar Alamat'"
				:show-search="true"
				:type="'back'"
				@back="back"
				@search="search"
				v-if="!isSearch"
			/>

			<SOSearchBar
				v-if="isSearch"
				:value="searchKey.key"
				:context="'Alamat'"
				:data-count="pageSetting.listLoading ? 0 : alamatData.data.length"
				:waiting="pageSetting.search.waiting"
				@loading="(waiting) => { pageSetting.search.waiting = waiting; pageSetting.listLoading = waiting }"
				@close="closeSearch"
				@do-search="searchCustomer"
			/>

			<div class="content-wrapper alamat-content" :class="{'main-page': !isSearch}">
				<div class="p-x-20 p-y-16 w-limit" v-if="pageSetting.listLoading">
					<SOCardCustomerAlamatSkeleton/>
				</div>
				<!--<div class="p-x-20 p-t-16 p-d-72 w-limit" v-else>-->
				<div class="p-x-20 p-t-16 w-limit" v-else>
					<SOEmptyState
						v-if="alamatData.data.length === 0 && !isSearch"
						:message="'Belum ada alamat terdaftar'"
						:sub-message="'Klik tombol + untuk menambahkan'"
					/>

					<SOHeaderList
						v-if="alamatData.data.length > 0 && !isSearch"
						:title="'Total ' + formatRupiah(alamatData.data.length) + ' Alamat'"
						:show-filter="false"
					/>

					<SOCardCustomerListAlamat
						v-for="alamat in alamatData.data"
						:key="alamat.idalamat"
						:alamat="alamat"
						:idalamat="alamat.idalamat"
						:idcustomer="idcustomer"
						@delete="showModalDelete"
					/>

					<SOLoadMoreLoading :id="'loading-alamat'" :loading="pageSetting.loadMoreloading"/>
				</div>
			</div>
		</div>

		<SOFABRegular @add="createAlamat()" v-if="!isSearch && validateAccess('customerRegular.create')"/>

		<div class="modal fade" id="modal-delete" role="dialog" data-backdrop="static">
			<div class="modal-dialog modal-lg  bani-modal">
				<div class="modal-content w-limit">
					<div class="modal-header">
						<div class="nav-btn kiri"></div>
						<h5 class="navbar-title text-center">Hapus Alamat Konsumen</h5>
						<div class="nav-btn kanan tutup">
							<img src="@/assets/img/x2.svg" @click="close">
						</div>
					</div>
					<div class="modal-body">
						<div class="f-regular f-16 f-c-black">
							Yakin ingin menghapus alamat ini?
						</div>
					</div>
					<div class="modal-footer">
						<SOButton
							:text="'Ya, Hapus'"
							:full="true"
							:outline="true"
							:disable="pageSetting.btn.del.disabled"
							:loading="pageSetting.btn.del.loading"
							@action="deleteAlamat"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOCardCustomerAlamatSkeleton from "@/so-components/modules/customer/SOCardCustomerAlamatSkeleton";
import SOCardCustomerListAlamat from "@/so-components/modules/customer/SOCardCustomerListAlamat";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import SOFABRegular from "@/so-components/global/ui/SOFABRegular";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
	name: "CustomerAlamat",
	components: {
		SOTitleBar,
		SOSearchBar,
		SOEmptyState,
		SOHeaderList,
		SOCardCustomerAlamatSkeleton,
		SOCardCustomerListAlamat,
		SOLoadMoreLoading,
		SOFABRegular,
		SOButton,
	},
	computed: {
		...mapGetters("customerModule", {
			alamatData: "getAlamat",
			pagination: "getPaginationAlamat",
			isSearch: "getIsSearchAlamat",
			searchKey: "getSearchAlamat",
		})
	},
	data() {
		return {
			idcustomer: "",
			alamatToDelete: {},

			pageSetting: {
				listLoading: true,
				loadMoreloading: false,
				btn: {
					del: {
						disabled: false,
						loading: false,
					}
				},
				search: {
					waiting: false
				}
			}
		}
	},
	mounted() {
		this.defaultSearch()
		this.idcustomer = this.$route.params.id
		this.listAlamat()
		this.scroll()
	},
	methods: {
		back() {
			// this.$router.push("/konsumen/detail/" + this.idcustomer)
			this.$router.back()
		},
		async search() {
			await this.$store.commit("customerModule/setIsSearchAlamat", true)
			await this.resetAlamat()
		},
		async closeSearch() {
			await this.$store.commit("customerModule/setIsSearchAlamat", false)
			await this.resetAlamat()
			await this.listAlamat()
		},
		async searchCustomer(search) {
			await this.resetAlamat()
			await this.$store.commit("customerModule/setSearchAlamat", search)
			await this.listAlamat()
			this.pageSetting.search.waiting = false
		},
		async listAlamat() {
			await this.resetAlamat()
			if (!this.pageSetting.listLoading) {
				this.pageSetting.loadMoreloading = true
			} else {
				this.pageSetting.listLoading = false
			}
			const res = await this.$store.dispatch("customerModule/fetchAlamatList", this.idcustomer)
			this.pageSetting.loadMoreloading = false
			if (res.success) {
				await this.$store.commit("customerModule/setNextPaginationAlamat", {data: this.alamatData.data})
			} else {
				this.$toast.error(res.err)
			}
		},
		defaultSearch() {
			let query = this.$route.query
			if (query.key) {
				this.$store.commit("customerModule/setSearchAlamat", query.key)
				this.$store.commit("customerModule/setIsSearchAlamat", true)
			}
		},
		async scroll() {
			window.onscroll = async () => {
				let payload = {
					idLoadMore: "loading-alamat",
					container: "alamat-content",
					pagination: this.pagination,
					callback: this.listAlamat,
				}
				await this.$store.dispatch("helper/scroll", payload)
			}
		},
		createAlamat() {
			this.$router.push("/konsumen/alamat/create/" + this.idcustomer)
		},
		showModalDelete(alamat) {
			this.alamatToDelete = alamat
			$("#modal-delete").modal("show");
		},
		async deleteAlamat() {
			this.pageSetting.btn.del.disabled = true
			this.pageSetting.btn.del.loading = true
			const res = await this.$store.dispatch("customerModule/deleteAlamat", this.alamatToDelete)
			this.pageSetting.btn.del.disabled = false
			this.pageSetting.btn.del.loading = false
			if (res.success) {
				let newDataAlamat = this.alamatData
				this.$toast.success(res.msg)
				newDataAlamat.data = newDataAlamat.data.filter((a) => a !== this.alamatToDelete)
				await this.$store.commit("customerModule/resetAlamat")
				await this.$store.commit("customerModule/setAlamat", newDataAlamat)
				$("#modal-delete").modal("hide");
			} else {
				this.$toast.error(res.err)
			}
		},
		close() {
			this.alamatToDelete = {}
			$("#modal-delete").modal("hide");
		},
		async resetAlamat() {
			if (this.alamatData.data !== undefined) {
				this.alamatData.data = []
			}
			await this.$store.commit("customerModule/resetSearchAlamat")
			await this.$store.commit("customerModule/resetPaginationAlamat")
			await this.$store.commit("customerModule/resetAlamat")
		},
	},
	beforeDestroy() {
		this.$store.commit("customerModule/resetPaginationAlamat")
		this.$store.commit("customerModule/resetAlamat")
	}
}
</script>